export const SET_PATIENT = 'SET_PATIENT';

/**
 * Change a setting value
 * payload.name: name of the setting prop to change
 * payload.value: new value to apply
 */
export function setPatient(value) {
    return { type: SET_PATIENT, value };
}